interface PageHeaderProps {
  title: string;
  description?: string;
}

// Shared page-title pattern - previously each page (or none, for Feedback)
// implemented its own heading markup inconsistently. This is the one
// convention every top-level page should use.
export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div>
      <h1 className="text-2xl font-semibold">{title}</h1>
      {description && <p className="text-muted-foreground">{description}</p>}
    </div>
  );
}
